import axios from 'axios'
import axiosRetry from 'axios-retry'

const UserStore = {
  namespaced: true,
  state: {
    currentUser: {
      permittedSituations: [
        'site_design_configuration',
        'admin_management',
        'expert_management',
        'contributor_management',
        'order_management',
        'tag_management',
        'picture_management',
        'widget_management',
        'character_image_management',
        'regulation_check_management',
        'feature_management',
        'post_list_management',
        'contact_management',
        'media_page_management',
        'footer_link_management',
        'html_page_management'
      ]
    }
  },
  mutations: {
    setCurrentUser (state, user) {
      state.currentUser = user
    }
  },
  getters: {
    judgePermissionBySituations: (state) => (situations) => {
      const uniqSituations = [...new Set(situations)]
      const mergedSituations = uniqSituations.concat([
        'site_design_configuration',
        'admin_management',
        'expert_management',
        'contributor_management',
        'order_management',
        'tag_management',
        'picture_management',
        'widget_management',
        'character_image_management',
        'regulation_check_management',
        'feature_management',
        'post_list_management',
        'contact_management',
        'media_page_management',
        'footer_link_management',
        'html_page_management'
      ])
      // const mergedSituations = state.currentUser.permitted_situations.concat(
      //       uniqSituations
      //     )
      const uniqMergedSituations = [...new Set(mergedSituations)]

      if (mergedSituations.length === uniqMergedSituations.length) {
        return false
      } else {
        return true
      }
    }
  },
  actions: {
    fetchCurrentUser (context) {
      axiosRetry(axios, { retries: 2 })
      return axios.get('/api/current_user_reference').then(
        ({ data }) => {
          const user = data.data.attributes
          context.commit('setCurrentUser', user)
        },
        (error) => {
          if (error.response.status === 403) {
            context.commit('errorPage/setForbidden', true, { root: true })
          }
          return Promise.reject(error)
          // const payload = {
          //           status: error.response.status,
          // message: `ユーザー情報の取得に失敗しました（${error.response.data.errors.toString()}）`,
          // }
          // context.dispatch('SystemMessageStore/createMessage', payload, {
          // root: true,
          // })
        }
      )
    }
  }
}

export default UserStore
